
import { profileTranslations } from './translations/profile';
import { featuresEs } from './translations/es/features';
import { subscription } from './translations/es/subscription';
import { goals } from './translations/es/goals';
import { general } from './translations/es/general';
import { timeManagement } from './translations/es/time-management';
import { habits } from './translations/es/habits';
import { journal } from './translations/es/journal';
import { finance } from './translations/es/finance';
import { reminders } from './translations/es/reminders';
import { feedback } from './translations/es/feedback';
import { dashboard } from './translations/es/dashboard';
import { notes } from './translations/es/notes';
import { auth } from './translations/es/auth';
import { tasks } from './translations/es/tasks';
import { settings } from './translations/es/settings';
import { blog } from './translations/es/blog';
import { orders } from './translations/es/orders';
import { products } from './translations/es/products';
import { admin } from './translations/es/admin';
import { lists } from './translations/es/lists';
import { ideas } from './translations/es/ideas';
import { email } from './translations/es/email';
import { documents } from './translations/es/documents';
import { productivity } from './translations/es/productivity';
import { landing } from './translations/es/landing';
import { financialEducation } from './translations/es/financial-education';
import { productivityEducation } from './translations/es/productivity-education';
import { annualPlan } from './translations/es/annual-plan';

// Traducciones principales en español
// Helper para aplanar módulos anidados con prefijo con punto
const flattenWithPrefix = (obj: any, prefix: string): Record<string, string> => {
  const result: Record<string, string> = {};
  const walk = (o: any, path: string[]) => {
    Object.entries(o).forEach(([k, v]) => {
      const next = [...path, k];
      if (v && typeof v === 'object' && !Array.isArray(v)) {
        walk(v, next);
      } else {
        result[`${prefix}.${next.join('.')}`] = String(v);
      }
    });
  };
  walk(obj, []);
  return result;
};

// Traducciones principales en español
const translations = {
  ...general,
  ...auth,
  ...profileTranslations,
  // Sobrescribe con traducciones en español
  userProfile: 'Perfil de Usuario',
  identity: 'Identidad',
  contactInfo: 'Información de Contacto',
  security: 'Seguridad',
  preferences: 'Preferencias',
  support: 'Soporte',
  authRequired: 'Autenticación Requerida',
  pleaseLoginToViewProfile: 'Por favor inicia sesión para ver tu perfil.',
  profileUpdated: 'Perfil Actualizado',
  profileSectionUpdated: 'Tu información de {section} fue actualizada exitosamente.',
  updateError: 'Error de Actualización',
  couldNotUpdateProfile: 'No se pudo actualizar el perfil. Por favor intenta de nuevo.',
  errorLoadingProfile: 'Error al Cargar el Perfil',
  tryRefreshPage: 'Por favor intenta actualizar la página.',
  // Contact info translations
  email: 'Dirección de Correo',
  emailCannotBeChanged: 'La dirección de correo no puede ser cambiada.',
  phone: 'Número de Teléfono',
  optionalForSmsNotifications: 'Opcional. Usado para notificaciones SMS si están habilitadas.',
  country: 'País',
  selectCountry: 'Selecciona un país',
  language: 'Idioma',
  selectLanguage: 'Selecciona un idioma',
  saving: 'Guardando',
  invalidPhoneNumber: 'Número de Teléfono Inválido',
  pleaseEnterValidPhone: 'Por favor ingresa un número de teléfono válido.',
  contactInfoUpdated: 'Información de contacto actualizada exitosamente.',
  couldNotUpdateContact: 'No se pudo actualizar la información de contacto. Por favor intenta de nuevo.',
  ...subscription,
  ...goals,
  ...timeManagement,
  ...habits,
  ...journal,
  ...finance,
  ...reminders,
  ...feedback,
  ...dashboard,
  ...notes,
  ...featuresEs,
  ...tasks,
  ...settings,
  ...blog,
  ...orders,
  ...products,
  ...admin,
  ...lists,
  ...ideas,
  ...email,
  ...documents,
  ...productivity,
  ...landing, // Spread landing for direct access (e.g., t('heroTitle'))
  ...financialEducation,
  ...flattenWithPrefix(productivityEducation, 'productivityEducation'),
  ...annualPlan,
  // Also add nested access for newsletter popup
  landing, // Add nested structure for dot notation (e.g., t('landing.newsletter.comingSoon'))
  // Additional translations
  tryAgainLater: 'Por favor intenta de nuevo más tarde.',
  recentTransactions: 'Transacciones Recientes',
  saveAndNew: 'Guardar y Nuevo',
  saveChanges: 'Guardar Cambios',

  // Mapeo de claves con puntos esperado por los componentes
  'finance.transactions.voucher.short': finance.voucherShort,
  'finance.transactions.voucher.label': finance.voucherLabel,
  'finance.transactions.voucher.dragOrClick': finance.voucherDragOrClick,
  'finance.transactions.voucher.dropHere': finance.voucherDropHere,
  'finance.transactions.voucher.supportedFormats': finance.voucherSupportedFormats,
  'finance.transactions.voucher.uploaded': finance.voucherUploaded,
  'finance.transactions.voucher.view': finance.voucherView,
  'finance.transactions.voucher.preview': finance.voucherPreview,
  'finance.transactions.voucher.invalidFileType': finance.voucherInvalidFileType,
  'finance.transactions.voucher.allowedTypes': finance.voucherAllowedTypes,
  'finance.transactions.voucher.fileTooLarge': finance.voucherFileTooLarge,
  'finance.transactions.voucher.maxSize': finance.voucherMaxSize,
  'finance.transactions.voucher.uploadError': finance.voucherUploadError,
  'finance.transactions.voucher.uploadSuccess': finance.voucherUploadSuccess,
  'finance.transactions.voucher.deleteSuccess': finance.voucherDeleteSuccess,
};

export const es = translations;
export default translations;
